export const slicesArray = [
  "omsOrders",
  "omsActiveRunners",
  "pizzaSlice",
  "basketSlice",
  "recentlyViewedSlice",
];
export const listToBeReseted = [
  "omsOrders",
  "omsActiveRunners",
  "pizzaSlice",
  "basketSlice",
  "recentlyViewedSlice",
];
